// src/components/input/index.js
import React from 'react'

const TextInput = ({
  label,
  name,
  required,
  type = 'text',
  value,
  onChange,
  placeholder = '',
  // NEW:
  rightIcon,
  onRightIconClick,
  inputClassName = '',
}) => {
  return (
    <div className="flex flex-col gap-2">
      {label && (
        <label htmlFor={name} className="text-[14px] font-normal">
          {label}{required && <sup>*</sup>}
        </label>
      )}

      {/* make the input the positioning context */}
      <div className="relative">
        <input
          id={name}
          name={name}
          type={type}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          required={required}
          className={`w-full px-8 py-3.5 rounded-2xl border border-[#CEE1FF] focus:ring-0 focus:outline-none pr-12 ${inputClassName}`}
        />
        {rightIcon && (
          <button
            type="button"
            onClick={onRightIconClick}
            className="absolute inset-y-0 right-3 flex items-center text-gray-500 hover:text-gray-700"
            aria-label="Toggle visibility"
          >
            {rightIcon}
          </button>
        )}
      </div>
    </div>
  )
}

export default TextInput
